import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../utils/customBaseQuery";

export const SessionApi = createApi({
  reducerPath: "sessionApi",
  baseQuery: customBaseQuery,
  keepUnusedDataFor: 60,
  refetchOnMountOrArgChange: true,
  tagTypes: ["sessionAPI"],
  endpoints: (builder) => ({
    getEventWithID: builder.query({
      query: (id) => ({
        url: `/event/${id}`,
        method: "GET"
      }),
      providesTags: ["sessionAPI"],
      keepUnusedDataFor: 0.0001
    }),
    postSessionApi: builder.mutation({
      query: (data) => ({
        url: `/session/${data?.id}`,
        method: "POST",

        body: data
      }),
      invalidatesTags: ["sessionAPI"]
    }),
    postAgendaApi: builder.mutation({
      query: (data) => ({
        url: "/agenda",
        method: "POST",

        body: data
      }),
      invalidatesTags: ["sessionAPI"]
    }),
    getSessionByIdApi: builder.query({
      query: (id) => ({
        providesTags: ["sessionAPI"],
        url: `/session/${id}`,
        method: "GET"
      }),
      providesTags: ["sessionAPI"]
    }),
    getAllAgendasBySessionIdApi: builder.query({
      query: (sessionId) => ({
        url: `/agenda/all/${sessionId}`,
        method: "GET"
      })
    }),
    getAllSurveyStatusByEventIdApi: builder.query({
      query: (id) => ({
        url: `/event/survey/enabled/${id}`,
        method: "GET"
      })
    }),
    createSessionPostPublish: builder.mutation({
      query: (payload) => ({
        url: `/session/add-session`,
        method: "POST",
        body: payload
      }),
      invalidatesTags: ["sessionAPI"]
    })
  })
});

export const {
  useGetEventWithIDQuery,
  useLazyGetEventWithIDQuery,
  usePostSessionApiMutation,
  useGetSessionByIdApiQuery,
  useLazyGetSessionByIdApiQuery,
  usePostAgendaApiMutation,
  useGetAllSurveyStatusByEventIdApiQuery,
  useLazyGetAllSurveyStatusByEventIdApiQuery,
  useCreateSessionPostPublishMutation
} = SessionApi;
